import App from './app.class';
import { RouterObj } from './types';
import store from '@/store/index';

export default class LocationManager {
    /**
     * 新打开的 app
     * @param {App} app
     */
    static updateDesktopUrlByApp(app: App): void {
        LocationManager.updateDesktopUrl(app.desktopUrl);
    }

    /**
     * 关闭所有 app
     */
    static updateDesktopUrlWhenNoApp(): void {
        const url = location.protocol + '//' + location.host + '/desktop';
        LocationManager.updateDesktopUrl(url);
    }

    /**
     * app 内部页面变化的时候修改桌面的 url
     * @param app 当前应用
     * @param routerObj 新的路由信息
     */
    static updateDesktopUrlWhenRouteChange(app: App, routerObj: RouterObj): void {
        app.updateRouteInfo(routerObj);
        LocationManager.updateDesktopUrl(app.desktopUrl);
    }

    /**
     * 从一个 app 切换到另一个 app 的时候切换路由
     * @param app
     */
    static updateDesktopUrlWhenChangeApp(app: App): void {
        LocationManager.updateDesktopUrl(app.desktopUrl);
    }

    /**
     * 实际更新 url 操作者
     * @param newUrl
     */
    static updateDesktopUrl(newUrl: string): void {
        const state = { titLe: '', url: window.location.href };
        history.replaceState(state, '', newUrl);
    }
}
